import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "./MultiSelectDropdown";
import axios from "axios";
import {
  setNewQuestionForm,
  setState,
  uploadQuizExcel,
  fetchThemes,
  fetchQuizTypes,
  fetchSubjects,
  fetchSubjectBasedClassesData,
  resetQuizFilters,
} from "./redux/schoolQuizSlice";
import Loader from "./loader/loader";
import * as XLSX from "xlsx";
import "./errorLogs.css";

import API_BASE_URL, { SCHOOL_QUIZ_API_BASE_URL } from "../config";
import { getAgeGroups } from "../../School-Quiz-Mgt-admin/redux/thunk";

export default function SchoolQuizQuestion() {
  const [excelFile, setExcelFile] = useState(null);
  const fileInputRef = useRef(null);
  const {
    newQuestionForm = {},
    loading,
    subThemes,
    selectedSubThemes,
    quizType,
    subQuizType,
    quizTypesList,
    subjectsList,
    subjectBasedClasses,
  } = useSelector((state) => state.schoolQuiz || {});
  const [groups, setGroups] = useState([]);

  const [error, setError] = useState("");
  // classes/subjects from chapter slice

  const dispatch = useDispatch();
  const { themes = [] } = useSelector((state) => state.schoolQuiz || {});
  useEffect(() => {
    dispatch(fetchThemes());
    dispatch(fetchSubjects());
    dispatch(fetchQuizTypes());
    fetchGroups();
    return () => {
      dispatch(resetQuizFilters());
    };
  }, [dispatch]);

  // useEffect(() => {
  //   if (newQuestionForm?.subject_id) {
  //     const subject_id = newQuestionForm?.subject_id;
  //     dispatch(
  //       fetchSubjectBasedClassesData({
  //         subject_id,
  //       })
  //     );
  //   }
  // }, [dispatch, newQuestionForm?.subject_id]);
  useEffect(() => {
    const subject_id = newQuestionForm?.subject_id;

    // Clear old classes immediately when subject changes
    dispatch(
      setState({
        key: "subjectBasedClasses",
        value: { data: [] },
      }),
    );

    // Also clear previously selected class
    dispatch(
      setNewQuestionForm({
        key: "class_id",
        value: "",
      }),
    );

    if (subject_id) {
      dispatch(
        fetchSubjectBasedClassesData({
          subject_id: Number(subject_id),
        }),
      );
    }
  }, [dispatch, newQuestionForm?.subject_id]);
  const [selectedClassIds, setSelectedClassIds] = useState(
    (newQuestionForm.class_ids || newQuestionForm.class_id
      ? Array.isArray(newQuestionForm.class_ids)
        ? newQuestionForm.class_ids
        : [newQuestionForm.class_id]
      : []
    ).map(String),
  );

  //   const userStr = localStorage.getItem("user");
  // const userId = userStr ? JSON.parse(userStr).id : null;

  // safer userId parsing
  const userStr = localStorage.getItem("user");
  const userObj = userStr ? JSON.parse(userStr) : {};
  const userId = userObj?.id ?? userObj?.user_id ?? "";
  const difficultyOptions = [
    { id: "basic", name: "Basic Level" },
    { id: "advanced", name: "Advanced Level" },
    { id: "ultra", name: "Ultra Level" },
    { id: "docmaster", name: "Docmaster" },
  ];

  const handleFieldChange = (e) => {
    //debugger
    const { name, value } = e.target;
    // correct payload shape expected by reducer:
    dispatch(setNewQuestionForm({ key: name, value }));
  };

  const fetchGroups = async () => {
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      setGroups(res.data || []);
    } catch (err) {
      setError("Failed to fetch group data");
      console.error("fetchGroups error:", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleThemeChange = (e) => {
    //debugger;
    const value = e.target.value;
    // update redux form properly
    dispatch(setNewQuestionForm({ key: "theme_id", value }));
    dispatch(
      setState({
        key: "selectedSubThemes",
        value: [],
      }),
    );
    const filtered =
      themes.find((e) => e.theme_id === Number(value))?.sub_theme || [];
    dispatch(
      setState({
        key: "subThemes",
        value: filtered,
      }),
    );
  };

  // File handlers
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    setExcelFile(file);
  };

  const resetFileInput = () => {
    setExcelFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Upload enabled only when class, subject, difficulty are selected
  const isUploadEnabled = () => {
    if (quizType === "live" || quizType === "practice") {
      return (
        !!newQuestionForm?.class_id &&
        !!newQuestionForm?.subject_id &&
        !!newQuestionForm?.difficulty_level
      );
    }

    if (quizType === "thematic") {
      return (
        !!newQuestionForm?.theme_id &&
        !!newQuestionForm?.group_id &&
        !!newQuestionForm?.difficulty_level
      );
    }

    return false; // default: disabled
  };

  console.log("groups", JSON.stringify(groups));
  const handleUpload = async () => {
    if (!excelFile) return;

    // Validate headers: original simple format
    const fileData = await excelFile.arrayBuffer();
    const workbook = XLSX.read(fileData);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    const headers = jsonData[0]?.map((h) => h?.toString().trim()) || [];

    const requiredHeaders = [
      "question",
      "option_A",
      "option_B",
      "option_C",
      "option_D",
      "correct_option",
    ];

    const isValid =
      headers.length === requiredHeaders.length &&
      headers.every((header, index) => header === requiredHeaders[index]);

    // if (!isValid) {
    //   alert(
    //     `❌ Upload failed:\nColumn names must be exactly (and in order):\n${requiredHeaders.join(
    //       ", "
    //     )}`
    //   );
    //   resetFileInput();
    //   return;
    // }

    dispatch(setState({ key: "loading", value: true }));

    try {
      // Build payload depending on quiz type
      let payload = {
        created_by: userId,
        file: excelFile,
        difficultyLevel: newQuestionForm?.difficulty_level,
        quizType: subQuizType,
      };

      if (subQuizType === 1 || subQuizType === 2) {
        payload = {
          ...payload,
          classId: newQuestionForm?.class_id
            ? Number(newQuestionForm.class_id)
            : undefined,
          subjectId: newQuestionForm?.subject_id
            ? Number(newQuestionForm.subject_id)
            : undefined,
        };
      } else if (subQuizType === 3 || subQuizType === 4) {
        payload = {
          ...payload,
          theme_id: newQuestionForm.theme_id
            ? selectedSubThemes?.length
              ? selectedSubThemes
              : [newQuestionForm.theme_id]
            : [],
          // themeId: newQuestionForm?.theme_id
          //   ? Number(newQuestionForm.theme_id)
          //   : undefined,
          group_id: newQuestionForm?.group_id
            ? Number(newQuestionForm.group_id)
            : undefined,
          // age_group_id,
        };
      }
      const finalPayload = {
        user_id: payload.created_by,
        file: payload.file,
        level: payload.difficultyLevel,
        class_id: payload.classId,
        subject_id: payload.subjectId,
        theme_id: payload.themeId,
        groupId: payload.group_id,
        quizType: payload.quizType,
      };

      Object.keys(finalPayload).forEach(
        (key) => finalPayload[key] == null && delete finalPayload[key],
      );

      console.log("payload", payload);
      // dispatch upload
      const res = await dispatch(uploadQuizExcel(payload)).unwrap();

      alert(
        `✅ ${res.message || "Upload completed"}\nInserted: ${
          res.inserted ?? 0
        }\nSkipped: ${res.skipped ?? 0}`,
      );

      // reset fields after successful upload (only relevant fields)
      resetFileInput();

      // clear difficulty always
      dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));

      if (quizType === "live" || quizType === "practice") {
        dispatch(setNewQuestionForm({ key: "class_id", value: "" }));
        dispatch(setNewQuestionForm({ key: "subject_id", value: "" }));
        dispatch(setNewQuestionForm({ key: "group_id", value: [] }));
      } else if (quizType === "thematic") {
        dispatch(setNewQuestionForm({ key: "theme_id", value: "" }));
        dispatch(setNewQuestionForm({ key: "group_id", value: "" }));
      }
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert(`❌ Upload failed: ${err?.message || "Unknown error"}`);
      resetFileInput();
    } finally {
      dispatch(setState({ key: "loading", value: false }));
    }
  };

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            School Quiz Questions
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Select Quiz Type */}
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Quiz Type
              </label>
              <div className="col-sm-8 d-flex align-items-center gap-3">
                {[
                  { label: "Live", value: 1 },
                  { label: "Practice", value: 0 },
                ].map((option) => (
                  <label
                    key={option.value}
                    className="form-check-label d-flex align-items-center gap-2"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name="quizType"
                      value={option.value}
                      checked={quizType === option.value} // loose equality to handle number/string
                      onChange={(e) => {
                        dispatch(
                          setState({
                            key: "quizType",
                            value: Number(e.target.value),
                          }),
                        );
                        dispatch(
                          setNewQuestionForm({ key: "theme_id", value: "" }),
                        );
                      }}
                      disabled={loading}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
              {quizType !== "" && (
                <>
                  {(quizType === 1 || quizType === 0) && (
                    <label className="col-sm-4 col-form-label font-medium text-gray-700">
                      Sub Quiz Type
                    </label>
                  )}
                  <div className="col-sm-8 d-flex align-items-center gap-3 flex-wrap">
                    {quizTypesList?.data
                      ?.filter((e) => e.is_live === quizType)
                      .map((quiz) => (
                        <label
                          key={quiz.id}
                          className="form-check-label d-flex align-items-center gap-2"
                        >
                          <input
                            type="radio"
                            className="form-check-input"
                            name="subQuizType"
                            value={quiz.id}
                            checked={subQuizType == quiz.id} // == handles string vs number
                            onChange={(e) => {
                              dispatch(
                                setState({
                                  key: "subQuizType",
                                  value: Number(e.target.value),
                                }),
                              );
                              dispatch(
                                setNewQuestionForm({
                                  key: "theme_id",
                                  value: "",
                                }),
                              );
                            }}
                            disabled={loading}
                          />
                          {quiz.type.charAt(0).toUpperCase() +
                            quiz.type.slice(1)}
                        </label>
                      ))}
                  </div>
                </>
              )}
            </div>
            {(subQuizType === 1 || subQuizType === 2) && (
              <div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Select Subject
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      name="subject_id"
                      value={newQuestionForm?.subject_id || ""}
                      onChange={handleFieldChange}
                      // disabled={loading || !newQuestionForm?.class_id}
                    >
                      <option value="">-- Select Subject --</option>
                      {(subjectsList?.data || []).map((s) => (
                        <option key={s.subject_id} value={s.subject_id}>
                          {s.subject_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Select Class
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      name="class_id"
                      value={newQuestionForm?.class_id || ""}
                      onChange={(e) => {
                        handleFieldChange(e);
                      }}
                      disabled={loading || !newQuestionForm?.subject_id}
                    >
                      <option value="">-- Select --</option>
                      {(subjectBasedClasses?.data || []).map((s) => (
                        <option key={s.subject_id} value={s.class_id}>
                          {s.class_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}

            {(subQuizType === 3 || subQuizType === 4) && (
              <div>
                {/* Theme Dropdown */}
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label text-gray-700">
                    Theme
                  </label>

                  <div className="col-sm-8">
                    <select
                      // className="form-control"
                      className="form-select"
                      name="theme_id"
                      value={newQuestionForm?.theme_id || ""}
                      onChange={handleThemeChange}
                      disabled={loading}
                    >
                      <option value="">-- Select Theme --</option>
                      {themes.map((theme) => (
                        <option key={theme.theme_id} value={theme.theme_id}>
                          {theme.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {newQuestionForm.theme_id && subThemes?.length > 0 && (
                  <div>
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label text-gray-700">
                        Sub Themes
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-select"
                          value={selectedSubThemes?.[0] || ""}
                          onChange={(e) => {
                            dispatch(
                              setState({
                                key: "selectedSubThemes",
                                value: [Number(e.target.value)],
                              }),
                            );
                          }}
                          style={{ minWidth: "250px", padding: "6px" }}
                        >
                          <option value="">Select Sub Theme</option>
                          {subThemes.map((e) => (
                            <option key={e.theme_id} value={e.theme_id}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {/* {newQuestionForm.theme_id &&
                  subThemes?.length > 0 &&
                  subThemes.map((e) => {
                    const selected = selectedSubThemes || []; // fallback in case it's undefined

                    return (
                      <label
                        key={e.theme_id}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "16px", // space between labels
                          // marginRight: "16px", // space between labels
                          marginBottom: "8px", // small vertical gap
                        }}
                      >
                        <input
                          type="checkbox"
                          style={{ marginRight: "20%" }}
                          value={e.theme_id}
                          checked={selected.includes(e.theme_id)}
                          onChange={(event) => {
                            const isChecked = event.target.checked;
                            let updatedList = [];

                            if (isChecked) {
                              updatedList = [...selected, e.theme_id];
                            } else {
                              updatedList = selected.filter(
                                (id) => id !== e.theme_id
                              );
                            }

                            dispatch(
                              setState({
                                key: "selectedSubThemes",
                                value: updatedList,
                              })
                            );
                          }}
                          className="mr-2"
                        />
                        <span className="text-gray-700">{e.name}</span>
                      </label>
                    );
                  })} */}

                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Groups
                  </label>
                  <div className="col-sm-8">
                    <div className="col-sm-8">
                      <select
                        className="form-select"
                        name="group_id"
                        value={newQuestionForm?.group_id || ""}
                        onChange={handleFieldChange}
                        disabled={loading}
                      >
                        <option value="">-- Select Group --</option>
                        {groups?.data?.map((g) => (
                          <option key={g.group_id} value={g.group_id}>
                            {g.group_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label font-medium text-gray-700">
                  Select Difficulty Level
                </label>
                <div className="col-sm-8">
                  <select
                    // className="form-control"
                    // className={`btn btn-success w-100 ${
                    className={`form-control ${
                      !subQuizType ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    name="difficulty_level"
                    value={newQuestionForm?.difficulty_level || ""}
                    onChange={handleFieldChange}
                    disabled={!subQuizType || loading}
                  >
                    <option value="">-- Select --</option>
                    {difficultyOptions.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* helper: required excel header */}
            <div className="row mb-3">
              <div className="col-sm-12">
                <small className="text-muted">
                  Required Excel columns (first row / header):{" "}
                  <strong>
                    question, option_A, option_B, option_C, option_D,
                    correct_option
                  </strong>
                  . Keep exact spelling & order. Class/Subject/Difficulty are
                  sent separately from the form.
                </small>
              </div>
            </div>

            {/* File input (always enabled so picker opens) */}
            <div className="row mb-5">
              <div className="col-md-8">
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx, .xls"
                  className="form-control"
                  disabled={!subQuizType || loading}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-4 text-end">
                <button
                  className={`btn btn-success w-100 ${
                    !excelFile ||
                    !subQuizType ||
                    !newQuestionForm?.difficulty_level
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={!excelFile || loading}
                  onClick={handleUpload}
                >
                  Bulk Upload
                </button>
              </div>
              <br />
            </div>

            {loading && <Loader />}
          </div>
        </div>
      </div>
    </div>
  );
}
